import * as types from '../actions/fryChutesAction';

const initialState = {
  restaurantUuid: null,
  interval: null,
  startDate: null,
  endDate: null,
  timeInterval: null,
  timezone: null,
  packageTypes: [],
  limit: '20',
  realtime: false,
  loading: true,
  sortBy: 'createdDate',
  orderDirection: 'DESC',
  scrollLoading: false,
  isFileLoading: false,
  cursorDirection: 'FIRST',
  cursor: null,
  existNext: false,
  existPrevious: false,
  changePage: false,
  chartLoading: false,
  graphContent: [],
  chartHeader: [],
  data: [],
  total: null,
};

const fryChutesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_FRY_CHUTES_EVENTS_VALUE:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };

    case types.CHANGE_FRY_CHUTES_SEVERAL_VALUES:
      return {
        ...state,
        ...action.payload,
      };

    case types.GET_FRY_CHUTES_EVENTS:
      return {
        ...state,
        loading: action.payload,
        scrollLoading: !action.payload,
      };

    case types.GET_FRY_CHUTES_EVENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        scrollLoading: false,
        cursor: action.payload.cursor,
        cursorDirection: action.payload.cursorDirection,
        existNext: action.payload.existsNextPage,
        existPrevious: action.payload.existsPreviousPage,
        data:
          action.params.cursorDirection === 'NEXT'
            ? [...state.data, ...action.payload.content]
            : action.payload.content,
      };

    case types.GET_FRY_CHUTES_EVENTS_ERROR:
      return {
        ...state,
        loading: false,
        scrollLoading: false,
        existNext: false,
        data: [],
      };

    case types.GET_FRY_CHUTES_ANALYTIC:
      return {
        ...state,
        chartLoading: true,
      };

    case types.GET_FRY_CHUTES_ANALYTIC_SUCCESS:
      const { results, total } = action.payload;
      return {
        ...state,
        chartLoading: false,
        chartHeader: results.length !== 0 ? Object.keys(results[0].values[0][1]) : [],
        total,
        graphContent:
          results.length !== 0
            ? results[0].values.map((item, index) => [
                new Date(item[0] * 1000),
                ...Object.keys(item[1]).map((material) => {
                  return results.reduce(function (sum, elem) {
                    return (
                      sum + Number(elem.values[index][1][material] > 0 ? elem.values[index][1][material] : 0)
                    );
                  }, 0);
                }),
              ])
            : [[0, 0]],
      };

    case types.LOAD_FRY_CHUTES_FILE:
      return {
        ...state,
        isFileLoading: true,
      };

    case types.LOAD_FRY_CHUTES_SUCCESS:
      return {
        ...state,
        isFileLoading: false,
      };

    case types.LOAD_FRY_CHUTES_ERROR:
      return {
        ...state,
        isFileLoading: false,
      };

    case types.RESET_FRY_CHUTES_EVENTS_STORE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default fryChutesReducer;
